import { render } from "./PhonePreview.vue?vue&type=template&id=6fa22c6f&scoped=true"
import script from "./PhonePreview.vue?vue&type=script&lang=js"
export * from "./PhonePreview.vue?vue&type=script&lang=js"

import "./PhonePreview.vue?vue&type=style&index=0&id=6fa22c6f&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fa22c6f"]])

export default __exports__